var _path, _path2, _path3, _path4, _path5, _path6, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgYellowStars(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 70,
    height: 69,
    viewBox: "0 0 70 69",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M37.0617 23.6196C36.632 23.363 36.7315 22.7231 37.1835 22.5621L42.0785 20.7381C42.2733 20.6755 42.4277 20.5063 42.4609 20.293L43.7127 15.173C43.8342 14.6663 44.4516 14.5404 44.7453 14.9395L47.8112 19.0188C47.9287 19.1785 48.1271 19.2757 48.3292 19.2575L53.4808 18.7122C53.9732 18.6577 54.2705 19.2167 53.9947 19.6171L50.998 23.9685C50.8877 24.1286 50.8545 24.3419 50.9353 24.555L52.8655 29.3477C53.0527 29.7914 52.6335 30.2899 52.156 30.1578L47.2332 28.7747C47.0421 28.7219 46.8216 28.7668 46.6856 28.9093L42.7451 32.3745C42.3665 32.7041 41.7787 32.4567 41.7863 31.9503L41.7448 26.7267C41.7339 26.5224 41.6348 26.3361 41.4805 26.2298L37.0617 23.6196Z",
    fill: "#FFC71B"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M47.3717 27.2546C46.7471 27.0606 46.0673 27.2221 45.5711 27.6675L42.8031 30.0905L42.7719 26.4482C42.7759 25.7819 42.4272 25.1875 41.8688 24.8423L38.8348 23.0284L42.2488 21.7587C42.6384 21.6334 42.9802 21.3572 43.2192 21.0102C43.3663 20.7966 43.4693 20.592 43.5208 20.3521L44.3898 16.7787L46.5231 19.6253C46.927 20.1396 47.5405 20.4047 48.1908 20.341L51.7771 19.9771L49.6812 23.0204C49.2951 23.581 49.2029 24.2652 49.4635 24.8776L50.8103 28.2059L47.3717 27.2546Z",
    fill: "url(#paint0_linear_12713_157739)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M39.5583 42.5346C39.2854 41.9665 39.8347 41.3638 40.4212 41.509L43.0005 42.123C43.2485 42.1926 43.5282 42.1223 43.7113 41.9214L45.6683 40.1162C46.1481 39.6687 46.8837 39.9657 46.9147 40.5889L47.0827 43.1911C47.0951 43.4403 47.2357 43.6803 47.4606 43.8016L49.7997 45.0209C50.3545 45.306 50.2781 46.0995 49.7102 46.3282L47.2115 47.3346C46.9843 47.4261 46.8012 47.627 46.7379 47.9067L46.2352 50.4823C46.1232 51.0783 45.3367 51.3104 44.9271 50.8397L43.2447 48.8474C43.0809 48.6591 42.8182 48.5531 42.5763 48.6081L39.9037 48.9641C39.277 49.0469 38.8319 48.3787 39.1919 47.8523L40.6257 45.6221C40.7563 45.4 40.7817 45.1355 40.6936 44.9167L39.5583 42.5346Z",
    fill: "#FFC71B"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M44.6826 48.4802C43.9453 47.6329 42.8566 47.2238 41.6937 47.3955L40.8253 47.5334L41.3158 46.7849C41.9369 45.8143 42.0326 44.6316 41.5457 43.6411L41.1847 42.8542L42.0571 43.0538C42.734 43.2049 43.4657 43.1645 44.1093 42.9053C44.4879 42.7528 44.875 42.5122 45.157 42.2291L45.7967 41.6324L45.8401 42.5049C45.8959 43.6266 46.5489 44.5925 47.5534 45.1203L48.3331 45.5267L47.5002 45.8621C46.4402 46.2891 45.6614 47.196 45.446 48.2998L45.256 49.1391L44.6826 48.4802Z",
    fill: "url(#paint1_linear_12713_157739)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M18.5028 26.7124C18.5244 26.1105 19.229 25.7843 19.7228 26.1363L25.7827 30.4762C25.9697 30.6127 26.203 30.6459 26.4449 30.5909L33.7889 28.3959C34.3715 28.2036 34.9009 28.7532 34.6985 29.3433L32.1797 36.4177C32.087 36.6246 32.1372 36.8586 32.2632 37.0621L36.5029 43.1097C36.8367 43.6109 36.4829 44.262 35.8648 44.2567L28.2199 44.2844C28.0012 44.2877 27.7362 44.3945 27.591 44.5801L22.8675 50.5507C22.4929 51.0406 21.7402 50.92 21.5578 50.3578L19.3795 43.3104C19.2914 43.0916 19.1276 42.9034 18.9321 42.855L11.7729 40.4835C11.2096 40.2866 11.0967 39.5692 11.6059 39.1947L17.888 34.7999C18.1004 34.672 18.1931 34.4651 18.2186 34.2006L18.5028 26.7124Z",
    fill: "#FFC71B"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M20.7281 41.963C20.5248 41.2397 19.9429 40.6689 19.2366 40.4448L13.8052 38.6488L18.5831 35.326C19.2058 34.9057 19.6206 34.1877 19.6592 33.4094L19.8933 27.7636L24.4866 31.0838C25.1001 31.5147 25.9053 31.6566 26.654 31.4398L32.2209 29.7487L30.286 35.1047C30.0373 35.7982 30.1417 36.6037 30.5722 37.2355L33.7871 41.8312L27.982 41.8384C27.6729 41.8358 27.3406 41.8848 27.0378 42.0068C26.6213 42.1745 26.2489 42.4517 25.9816 42.7712L22.397 47.3085L20.7281 41.963Z",
    fill: "url(#paint2_linear_12713_157739)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_12713_157739",
    x1: 58.0318,
    y1: 44.6579,
    x2: 49.6108,
    y2: 30.367,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.4302,
    stopColor: "#E3B117"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6573,
    stopColor: "#F1CF2B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8616,
    stopColor: "#FBE338"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FEEA3D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_12713_157739",
    x1: 44.2049,
    y1: 50.4491,
    x2: 45.193,
    y2: 31.5911,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0167598,
    stopColor: "#E3B117"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1838,
    stopColor: "#F1CF2B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.334,
    stopColor: "#FBE338"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4358,
    stopColor: "#FEEA3D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_12713_157739",
    x1: 22.5645,
    y1: 54.9163,
    x2: 23.7185,
    y2: 32.8925,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E3B117"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3986,
    stopColor: "#F1CF2B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7571,
    stopColor: "#FBE338"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FEEA3D"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgYellowStars);
export default __webpack_public_path__ + "static/media/yellow-stars.9c948d6cbaa5e443b80e8c9a095b3418.svg";
export { ForwardRef as ReactComponent };